import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./AccountIndicator.styled";
export var AccountIndicator = function (props) {
    var size = props.size, selected = props.selected, onClick = props.onClick, children = props.children;
    return (_jsx(S.CircleContainer, { style: { position: "relative" }, size: size, onClick: onClick, children: _jsx(S.IndicatorCircle, { size: size, selected: selected, children: children }) }));
};
